import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Glossary from "@/pages/Glossary";
import { buildGlossaryJsonLd } from "@/lib/seo/glossaryJsonLd";

export const Route = createFileRoute("/es/recursos/glosario/")({
  head: () => ({
    ...buildRouteHead("/es/recursos/glosario"),
    scripts: buildGlossaryJsonLd("es", "/es/recursos/glosario"),
  }),
  component: Glossary,
});
